import { SectionCard } from '@/components/ui/SectionCard';
import { useI18n } from '@/hooks/useI18n';
import { PublicationsTable } from './components/PublicationsTable';

const JournalsPage = () => {
  const { t } = useI18n();

  return (
    <section className="dashboard">
      <div className="dashboard-inner">
        <header className="dashboard-head">
          <div>
            <p className="breadcrumbs">{t('drawer.group.publications')}</p>
            <h2>{t('dashboard.publicationsTitle')}</h2>
          </div>
        </header>

        <div className="full-grid">
          <SectionCard title={t('drawer.link.journals')} span={12}>
            <PublicationsTable />
          </SectionCard>
        </div>
      </div>
    </section>
  );
};

export default JournalsPage;
